import {Configuration} from '@/model/types';
import {CURRENT_MODEL_VERSION} from '@/model/types/model-versions';

const ConfigurationCache: Record<string, Configuration> = {};

export const loadConfiguration = async (version?: string): Promise<Configuration> => {
  if (version && ConfigurationCache[version]) {
    return ConfigurationCache[version];
  }

  const shouldLoadCurrentVersion = !version || version === CURRENT_MODEL_VERSION;
  const configFile = await fetch(shouldLoadCurrentVersion ? '/model.json' : `/models/model_${version}.json`);
  const config = (await configFile.json()) as Configuration;

  if (!(config.version in ConfigurationCache)) {
    // Cache the configuration for ulterior loadings
    ConfigurationCache[config.version] = config;
  }

  return config;
};
